import React from "react";
import ReactDOM  from "react-dom";
import App from "./components/App";

const appElement = document.getElementById("root");

ReactDOM.render(<div> <App /> </div> , appElement);